import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import GetAdminCredentials from '../../../../context/GetAdminCredentials';






const longText = `
Aliquam eget finibus ante, non facilisis lectus. Sed vitae dignissim est, vel aliquam tellus.
Praesent non nunc mollis, fermentum neque at, semper arcu.
Nullam eget est sed sem iaculis gravida eget vitae justo.
`;


 function TooltipComponent({PersonData}) {


  return <div>
    
                     {
                            PersonData.length > 0 ? PersonData.map((item, index) => (
                                <div className='bg-gray-200 w-[100%] text-black rounded-md px-2 py-1 mb-2' key={index}>

                                    <p><strong>Name:</strong> {item.fname} {item.lname}</p>
                                        <p ><strong>Email:</strong> {item.email}</p>
                                    <p><strong>Role:</strong> {item.acct_typ}</p>
                                </div>
                            )) : <p>No Data Found</p>   
                        }</div>



}   
export default function SeePerson({senderToken}) {




              const [PersonData, setPersonData] = React.useState([]);
          
             useEffect(() => {
               
                       async function fetchData() {
                         
                            const response = await GetAdminCredentials(senderToken);
                            setPersonData(response);
                       }
                       
                       fetchData();

  
             }, [senderToken]);




  return (
    <div>
      <Tooltip title={<TooltipComponent PersonData={PersonData} />}>
        <Button sx={{ m: 1 }}>Treated By</Button>
                       
      </Tooltip>


                         
     
    </div>
  );
}
